/**
 * SectionCard (P26).
 *
 * Lifted from `sample-wireframe/client/src/pages/Home.tsx`. The
 * `accent-card` variant tints the card warm-cream for "first among equals"
 * panels (review pressure, integration readiness, etc.).
 */
import type { JSX, ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

import { cn } from '@/lib/utils.js';

interface SectionCardProps {
  icon: LucideIcon;
  title: string;
  text: string;
  children?: ReactNode;
  accent?: boolean;
}

export function SectionCard({
  icon: Icon,
  title,
  text,
  children,
  accent,
}: SectionCardProps): JSX.Element {
  return (
    <section className={cn('section-card', accent && 'accent-card')}>
      <div className="section-card-head">
        <div className="metric-icon small">
          <Icon size={16} aria-hidden />
        </div>
        <div>
          <h2>{title}</h2>
          <p>{text}</p>
        </div>
      </div>
      {children}
    </section>
  );
}
